import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_kam_source_kpi = {
	id: "REPORT_kam_source_kpi",
	name: "KPI KAM - source",
	data: [
		{
			id: "TRANSACTION_PAYMENT_DUE",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAIDçname|e=GOORDER",
			groups: ["NONE", "COMPANY_SOURCE"],
			columns: [
				{
					id: "summary",
					filter: "date|bt={date_range__QUARTER}",
				},
				{
					id: "monthly",
					group: "DATE_MONTH",
					filter: "date|bt={date_range__QUARTER}",
				},
			],
		},
	],
	table: [
		{
			id: "team_progress",
			name: "Zrodlo - w trakcie płatności",
			rows: [
				{
					id: "team",
					name: "team",
					data_id: "TRANSACTION_PAYMENT_DUE",
					group: "COMPANY_SOURCE",
					aggregate: "new_quantity_customer",
				},
			],
			columns: [
				{
					id: "new_quantity_customer",
					data_column_id: "summary",
					name: "Lokalizacje",
				},
				{
					id: "new_quantity_customer_monthly",
					data_column_id: "monthly",
					name: "Lokalizacje",
					values_dynamic: "values_previous_12_months",
				},
			],
		},
	],
} as ConfigReportComboApi;
